export interface IShareButton {
    title: string;
    icon: string;
    className: string;
    width: number;
    height: number;
}

const AuthorPageState: IShareButton[] = [
    {
        title: 'LinkedIn',
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="12" cy="12" r="11.5" stroke="#1D1D1F"/>\n' +
        '<path d="M8.89062 16.9091H6.54688V9.62216H8.89062V16.9091ZM7.79972 8.5142H7.78267C7.03267 8.5142 6.54688 7.95597 6.54688 7.2571C6.54688 6.54545 7.04545 6 7.8125 6C8.57955 6 9.0483 6.54119 9.06534 7.2571C9.06534 7.95597 8.57955 8.5142 7.79972 8.5142ZM17.456 16.9091H15.1122V12.9247C15.1122 11.9702 14.7713 11.3182 13.9233 11.3182C13.2756 11.3182 12.892 11.7571 12.7216 12.1832C12.6577 12.3366 12.6406 12.5455 12.6406 12.7585V16.9091H10.2969V9.62216H12.6406V10.6364C12.9815 10.1506 13.5142 9.4517 14.7543 9.4517C16.2926 9.4517 17.456 10.4659 17.456 12.652V16.9091Z" fill="white"/>\n' + 
        '</svg>',
        className: 'linked_img',
        width: 44,
        height: 44,
    },
]

export default AuthorPageState;
